import { motion } from "framer-motion";

const sections = [
  {
    title: "1. Genel Bilgilendirme",
    content: `
Bu web sitesinde yer alan tüm içerikler bilgilendirme amacıyla hazırlanmıştır. Site içerisinde yer alan bilgiler psikolojik danışmanlık ve psikoterapi hizmetleri hakkında genel bilgi sunmakta olup profesyonel psikoterapi hizmetinin yerine geçmez.
`
  },
  {
    title: "2. Hizmet Kapsamı",
    content: `
Web sitesinde yer alan içerikler psikolojik danışmanlık ve psikoterapi hizmetlerine ilişkin genel açıklamalar içermektedir. Web sitesi üzerinden yapılan başvurular, iletişim talepleri veya bilgi edinme amaçlı mesajlar tek başına bir terapi ilişkisi kurulması anlamına gelmez. Terapi süreci, gerekli değerlendirmelerin yapılması ve danışan ile karşılıklı onay sonrasında başlatılmaktadır.
`
  },
  {
    title: "3. Profesyonel Hizmet Uyarısı",
    content: `
Bu web sitesinde yer alan bilgiler herhangi bir birey için tanı koyma, tedavi planı oluşturma veya psikoterapi hizmeti sunma amacı taşımaz. Psikolojik destek ve psikoterapi hizmetleri yalnızca danışan ile yapılan değerlendirme görüşmeleri sonrasında ve profesyonel etik ilkeler çerçevesinde yürütülür. Web sitesinde yer alan bilgiler bireysel değerlendirme ve psikoterapi sürecinin yerine geçmez.
`
  },
  {
    title: "4. Sorumluluk Reddi",
    content: `
Web sitesinde yer alan tüm içerikler genel bilgilendirme amacı taşımaktadır. Kullanıcıların site içeriğine dayanarak alacakları kararlar ve bu kararların doğurabileceği sonuçlardan site sahibi sorumlu tutulamaz.
`
  },
  {
    title: "5. Fikri Mülkiyet Hakları",
    content: `
Bu web sitesinde yer alan tüm metinler, görseller, tasarımlar ve diğer içerikler telif hakkı mevzuatı kapsamında korunmaktadır. Site sahibinin yazılı izni olmaksızın bu içeriklerin kopyalanması, çoğaltılması, yeniden yayımlanması veya ticari amaçla kullanılması mümkün değildir.
`
  },
  {
    title: "6. Kullanıcı Yükümlülükleri",
    content: `
Kullanıcılar web sitesini yürürlükteki mevzuata ve genel ahlak kurallarına uygun şekilde kullanmayı kabul eder. Web sitesinin hukuka aykırı, yanıltıcı, zarar verici veya kötüye kullanım amacıyla kullanılması kabul edilemez.
`
  },
  {
    title: "7. Üçüncü Taraf Bağlantılar",
    content: `
Web sitesi zaman zaman üçüncü taraf internet sitelerine yönlendiren bağlantılar içerebilir. Bu bağlantılar kullanıcıya kolaylık sağlamak amacıyla sunulmaktadır. Bağlantı verilen sitelerin içerikleri ve gizlilik politikaları üzerinde site sahibinin herhangi bir sorumluluğu bulunmamaktadır.
`
  },
  {
    title: "8. Değişiklik Hakkı",
    content: `
Site sahibi, kullanım şartlarında gerekli gördüğü durumlarda değişiklik yapma hakkını saklı tutar. Güncellenen kullanım şartları web sitesinde yayımlandığı tarihten itibaren geçerli kabul edilir.
`
  },
  {
    title: "9. İletişim",
    content: `
Kullanım şartları ile ilgili sorularınız veya talepleriniz için aşağıdaki iletişim adresi üzerinden iletişime geçebilirsiniz.

E-posta: info@aysunseremet.com
`
  }
];

export default function TermsOfUse() {
  return (
    <section className="bg-gray-50 py-24 px-6 lg:px-12">
      
      {/* Başlık */}
      <motion.div
        className="max-w-4xl mx-auto text-center space-y-6"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false, amount: 0.3 }}
        transition={{ duration: 1.2, ease: "easeInOut" }}
      >
        <h1 className="text-4xl font-bold text-gray-900">
          Kullanım Şartları
        </h1>
        <p className="text-gray-600 text-lg sm:text-xl max-w-2xl mx-auto">
          Bu web sitesi, ziyaretçilere psikolojik danışmanlık hizmetleri hakkında genel bilgilendirme sağlamak amacıyla hazırlanmıştır. Web sitesini ziyaret eden ve kullanan tüm kullanıcılar aşağıda yer alan kullanım şartlarını kabul etmiş sayılır.
        </p>
      </motion.div>

      {/* İçerik */}
      <div className="mt-16 max-w-3xl mx-auto space-y-6">
        {sections.map((section, index) => (
          <motion.div
            key={index}
            className="bg-white rounded-2xl shadow-lg border border-gray-200 p-6"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false, amount: 0.2 }}
            transition={{
              duration: 0.8,
              delay: index * 0.1,
              ease: "easeInOut",
            }}
          >
            <h2 className="text-xl font-semibold text-gray-900 mb-3">
              {section.title}
            </h2>

            {section.content.split("\n").map((line, i) =>
              line.trim() ? (
                <p key={i} className="text-gray-700 leading-relaxed mb-2">
                  {line}
                </p>
              ) : null
            )}
          </motion.div>
        ))}
      </div>

    </section>
  );
}